import React, { useState } from "react";
import "./WhatWeDo.css";

const servicesData = [
  {
    id: 1,
    title: "Website Design & Development",
    summary:
      "Custom, responsive websites that capture your brand’s essence and convert visitors into loyal customers.",
    detail:
      "We don’t just build pages — we craft digital experiences. From pixel‑perfect front‑end design to robust back‑end architecture, every site is optimised for speed, accessibility, and search engines. Our process includes research, wireframing, prototyping, and iterative refinement until your vision shines.",
  },
  {
    id: 2,
    title: "Hosting & Maintenance",
    summary:
      "Reliable, secure hosting with proactive management, so your site stays fast and safe around the clock.",
    detail:
      "Forget server headaches. We offer managed hosting with 99.9% uptime, daily backups, SSL certificates, and real‑time monitoring. Our team handles updates, security patches, and performance optimisation so you can focus entirely on your business.",
  },
  {
    id: 3,
    title: "Web Applications & Software",
    summary:
      "Powerful, scalable web apps tailored to streamline your operations and accelerate growth.",
    detail:
      "Need a custom CRM, booking system, inventory dashboard, or AI‑powered tool? We engineer full‑stack applications using modern frameworks like React, Node.js, and Python. Every solution is built to scale with your business and integrate seamlessly with your existing tools.",
  },
  {
    id: 4,
    title: "Email & Communication Systems",
    summary:
      "Professional email addresses, newsletters, and automated communication that elevate your brand identity.",
    detail:
      "First impressions matter. We set up branded email (yourname@yourcompany.com), design newsletter templates, and implement automated workflows for lead nurturing, order confirmations, and client onboarding — all keeping your brand front and centre.",
  },
  {
    id: 5,
    title: "Technology Consulting",
    summary:
      "Not sure where to start? We guide you through the digital landscape and craft a roadmap for growth.",
    detail:
      "Our consulting process begins with a deep dive into your goals, audience, and operations. We then map out a technology strategy — selecting the right platforms, tools, and integrations — to future‑proof your business and maximise ROI.",
  },
  {
    id: 6,
    title: "Ongoing Support & Growth",
    summary:
      "Launch is just the beginning. We offer continuous improvement, A/B testing, content updates, and analytics to keep you ahead.",
    detail:
      "Digital landscapes evolve. We stay by your side with monthly analytics reports, conversion rate optimisation, content refreshes, and feature expansions. Our goal is to make your digital presence not just current, but consistently ahead of the curve.",
  },
];

const ServiceItem = ({ service, isOpen, onToggle }) => {
  return (
    <div className={`service-item-modern ${isOpen ? "is-open" : ""}`}>
      <button
        className="service-header-modern"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="service-num">
          {String(service.id).padStart(2, "0")}
        </span>
        <h3 className="service-title-text">{service.title}</h3>
        <span className="service-cross-icon"></span>
      </button>

      <div className="service-body-wrapper">
        <div className="service-summary-text">
          <p>{service.summary}</p>
        </div>
        <div className="service-detail-text">
          <p>{service.detail}</p>
        </div>
      </div>
    </div>
  );
};

const WhatWeDo = () => {
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="what-we-do-page">
      {/* Dynamic Header Overlay */}
      <div className="what-we-do-hero">
        <img
          src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1500&q=80"
          alt="Web development environment setup"
          className="what-we-do-hero-img"
        />
        <div className="hero-darkener"></div>
        <div className="what-we-do-hero-content">
          <h1 className="page-main-title">
            What <span className="text-gradient-amber">We Do</span>
          </h1>
          <p className="page-lead-paragraph">
            Full‑stack digital services mapped directly around enterprise
            metrics. Built with absolute speed, utility, and refined aesthetics.
          </p>
        </div>
      </div>

      <div className="container accordion-container">
        <div className="services-interactive-deck">
          {servicesData.map((service) => (
            <ServiceItem
              key={service.id}
              service={service}
              isOpen={openId === service.id}
              onToggle={() => handleToggle(service.id)}
            />
          ))}
        </div>
      </div>

      <div className="container cta-section-wrapper">
        <div className="cta-glass-box">
          <h3>Ready to Build Something Remarkable?</h3>
          <p>
            Let’s open a dialogue concerning your product scope and build an
            architecture suited for growth.
          </p>
          <a href="/contact" className="btn-modern btn-filled">
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
